import { createColorKeys } from '~/utils/chakraUtils'

import { activeCallBlockColors } from './ActiveCallBlock.colors'
import { callButtonColors } from './CallButton.colors'
import {
  callContactButtonColors,
  callContactButtonMenuColors,
} from './CallContactButton.colors'
import { callControlColors } from './CallControl.colors'
import { callSoundIndicatorColors } from './CallSoundIndicator.colors'
import { contactCardColors } from './ContactCard.colors'
import { contactCardsListColors } from './ContactCardsList.colors'
import { dialpadShowButtonColors } from './DialpadShowButton.colors'
import { emptyListItemColors } from './EmptyListItem.colors'
import { feedbackToastColors } from './FeedbackToast.colors'
import { incomingCallButtonColors } from './IncomingCallButton.colors'
import { keypadColors } from './Keypad.colors'
import { numberInputColors } from './NumberInput.colors'
import { parkCallMenuColors } from './ParkCallMenu.colors'
import { phoneSearchInputColors } from './PhoneSearchInput.colors'
import { quickDialViewColors } from './QuickDialView.colors'
import { transferHeaderColors } from './TransferHeader.colors'
import { webPhonePageColors } from './WebPhonePage.colors'

export const phoneColors = {
  Phone: {
    ActiveCallBlock: activeCallBlockColors,
    CallButton: callButtonColors,
    CallContactButtonMenu: callContactButtonMenuColors,
    CallContactButton: callContactButtonColors,
    CallControl: callControlColors,
    CallSoundIndicator: callSoundIndicatorColors,
    ContactCard: contactCardColors,
    ContactCardsList: contactCardsListColors,
    DialpadShowButton: dialpadShowButtonColors,
    EmptyListItem: emptyListItemColors,
    IncomingCallButton: incomingCallButtonColors,
    Keypad: keypadColors,
    NumberInput: numberInputColors,
    ParkCallMenuColors: parkCallMenuColors,
    PhoneSearchInput: phoneSearchInputColors,
    QuickDialViewColors: quickDialViewColors,
    TransferHeader: transferHeaderColors,
    WebPhonePage: webPhonePageColors,
    FeedbackToast: feedbackToastColors,
  },
}

export const phoneColorKeys = createColorKeys(phoneColors)
